module.exports = __webpack_public_path__ + "img/jstree-ocl-closed.a0d32f1.png";